// extracted by mini-css-extract-plugin
export var fadeIn = "_jx-1";
export var modalContent = "_jx-3";
export var overlay = "_jx-0";
export var popoverContent = "_jx-2";
export var results = "_jx-5";
export var searchInputWrapper = "_jx-4";